import { render, staticRenderFns } from "./NotList.vue?vue&type=template&id=a2a4cbfe&scoped=true"
import script from "./NotList.vue?vue&type=script&lang=ts"
export * from "./NotList.vue?vue&type=script&lang=ts"
import style0 from "./NotList.vue?vue&type=style&index=0&id=a2a4cbfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a4cbfe",
  null
  
)

export default component.exports